import { useState } from "react";

import { Accordion, Icon } from "semantic-ui-react";

type BasicAccordionProps = {
  content: React.ReactNode;
  title: React.ReactNode;
  style?: React.CSSProperties;
};

const BasicAccordion = ({ content, title, style }: BasicAccordionProps) => {
  const [accordionIndex, setAccordionIndex] = useState(-1);

  return (
    <Accordion style={style}>
      <Accordion.Title
        active={accordionIndex === 0}
        index={0}
        onClick={(_e, titleProps) => {
          if (!titleProps) return;
          const { index } = titleProps;
          setAccordionIndex(accordionIndex === index ? -1 : (index as number));
        }}
        style={{ marginBottom: 0, display: "flex", alignItems: "center" }}
      >
        <Icon name="dropdown" />
        {title}
      </Accordion.Title>
      <Accordion.Content active={accordionIndex === 0} index={0}>
        {content}
      </Accordion.Content>
    </Accordion>
  );
};

export default BasicAccordion;
